import { render, staticRenderFns } from "./addOrgaApartment.vue?vue&type=template&id=0321dd4e&scoped=true"
import script from "./addOrgaApartment.vue?vue&type=script&lang=js"
export * from "./addOrgaApartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0321dd4e",
  null
  
)

export default component.exports